<template>
    <div class="h5 mb-0">
        <div :class="iconClass" style="float: left">
            <b-icon :icon="icon" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        file: Object,
    },
    computed: {
        iconClass() {
            switch (this.file.asset_extension) {
                case 'pdf': 
                    return 'file-icon file-icon-pdf mr-2'
                case 'doc':
                case 'docx':
                    return 'file-icon file-icon-word mr-2'
                case 'jpeg':
                case 'jpg':
                case 'gif':
                case 'png':
                    return 'file-icon file-icon-image mr-2'
                default:
                    return 'file-icon file-icon-default mr-2' 
            }
        },
        icon() {
            switch (this.file.asset_extension) {
                case 'pdf': 
                    return 'file-earmark-richtext'
                case 'doc':
                case 'docx':
                    return 'file-earmark-word'
                case 'jpeg':
                case 'jpg':
                case 'gif':
                case 'png':
                    return 'file-earmark-image'
                default:
                    return 'file-earmark'
            }
        }
    }
}
</script>